export const GREY = {
  50: '#F9FAFB',
  100: '#E4E5F0',
  200: '#EAECF0',
  300: '#D0D5DD',
  400: '#98A2B3',
  500: '#667085',
  600: '#475467',
  700: 'hsl(var(--border))',
  800: '#212328',
  900: '#101828',
};

export const themeColors = {
  iconColor: 'red',
  primary: {
    main: '#fafafa',
    light: 'rgba(76, 83, 248, 0.08)',
    dark: 'var(--popover)',
    contrastText: '#FFFFFF',
  },
  background: {
    default: 'var(--popover)',
    paper: GREY[800],
    secondary: '#0F0F0F',
    tertiary: '#272938',
    graph6: '#6479A7',
    hover: '#30313E',
    panel: 'var(--popover)',
    violetHover: '#606ACB1A',
  },
  info: {
    main: '#4D5BC8',
    light: 'rgba(103, 122, 166, 0.20)',
  },
  success: {
    main: '#97E95F',
    light: 'rgba(151, 233, 95, 0.20)',
  },
  warning: {
    main: '#C69D61',
    light: 'rgba(234, 165, 61, 0.20)',
  },
  error: {
    dark: 'linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), #EC4C47',
    main: '#C66162',
    light: 'rgba(240, 155, 152, 0.20)',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#858697',
    disabled: 'rgba(147, 154, 192, 0.38)',
    contrastText: '#000000',
    light: '#DFE1ED',
    muted: '#27272A',
  },
  chart: {
    violet: '#505ED9',
    green: '#2A9D8F',
    yellow: '#E9C46A',
    blue: '#0099F7',
    red: '#E76F51',
  },
  common: {
    white: '#1B1C1F',
    black: '#000000',
  },
  grey: GREY,
  divider: '#27272a',
  action: {
    active: '#FFFFFF',
    disabled: '#A7A9B0',
  },
};
